import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Typography,
    TextField,
    FormHelperText,
    Button,
} from '@mui/material'

export default function ZipSearch({ handleSubmit }) {
    const [zipInput, setZipInput] = useState()
    const [error, setError] = useState()

    const handleInput = (e) => {
        setZipInput(e.target.value)
    }

    const handleZipSubmit = () => {
        if (!zipInput || zipInput.length < 5) {
            setError('Please enter a zipcode of at least 5 digits')
        }
        setError(null)
        handleSubmit(zipInput)
    }
    return (
        <Box noValidate autoComplete="off">
            <Typography variant="h2" color="black" sx={{ fontWeight: 'bold' }}>
                Find Your Candidates
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '30px',
                }}
            >
                <Box>
                    <Box
                        sx={{
                            p: 2,
                            my: 2,
                            backgroundColor: 'primary.dark',
                            borderRadius: '5px',
                            maxWidth: '150px',
                        }}
                    >
                        <div>
                            <TextField
                                placeholder="Zip Code"
                                size="small"
                                name="postalcode"
                                sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '5px',
                                }}
                                value={zipInput}
                                onChange={handleInput}
                                maxLength="5"
                                type="number"
                                error={error}
                            />
                            <FormHelperText sx={{ color: 'white' }}>
                                {error}
                            </FormHelperText>
                        </div>
                    </Box>
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: 'primary.dark' }}
                        onClick={handleZipSubmit}
                        disabled={
                            !zipInput || (zipInput && zipInput.length < 5)
                        }
                    >
                        Find Candidates
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

ZipSearch.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
}
